export const State = {
  Pending: 0,
  Occupied: 1,
  Answered: 2,
  Additional: 3,
  Closed: 4, // 상담 종료
} as const

export type State = (typeof State)[keyof typeof State]

export interface ConcernData {
  concern_lv: number // 1 - 10
  concern_lv_expression: string
  concern_lv_description: string
  issue_review: string
}

/** Find a vet block from the server (DRT-7237), detail response only; null when not rolled out */
export interface VetFinder {
  variant: 'monitor' | 'visit' | 'emergency'
  title: string
  body: string
  cta: string
  url: string
}

export type ConsultationState = {
  states?: State[]
}
